import dynamic from 'next/dynamic'
import { useMemo } from 'react'

import ParkinglotExtraInfoView from '@/components/detail/components/shared/parkinglotInfo/components/parkinglotExtra/view'
import ParkinglotOperationInfoView from '@/components/detail/components/shared/parkinglotInfo/components/parkinglotOperation/view'
import ParkinglotPriceInfoView from '@/components/detail/components/shared/parkinglotInfo/components/parkinglotPrice/view'
import SharedParkinglotPriceInfoView from '@/components/detail/components/shared/parkinglotInfo/components/shareParkinglotPrice/view'

import type { ParkinglotDetail, SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import type { SliderOptions } from '@/shared/components/slider/types/sliderOptions'

import { PARKINGLOT_TYPE } from '@/enums/detail'

const ParkinglotPhotoView = dynamic(
  () => import('@/components/detail/components/shared/parkinglotInfo/components/parkinglotPhoto/view'),
  { ssr: false }
)

interface ParkinglotInfoViewProps {
  pin: ParkinglotDetail | SharedParkinglotDetail
}

const ParkinglotInfoView = ({ pin }: ParkinglotInfoViewProps) => {
  const operationTimeInfo = useMemo(() => {
    const isTimeExists = pin.times.length > 0
    if (!isTimeExists) return []

    const timeList = pin.times[0].contents
    if (pin.type === PARKINGLOT_TYPE.PARKINGLOT) return timeList
    if (pin.type === PARKINGLOT_TYPE.SHARE) {
      const isSundayExists = timeList.some(({ key }) => key === '일요일')
      if (isSundayExists) {
        const [sunday, ...restDays] = timeList
        return [...restDays, sunday]
      } else {
        return timeList
      }
    }

    return []
  }, [pin.times, pin.type])

  const sliderOptions: SliderOptions = {
    fullScreen: true,
    pagination: true,
    paginationStyles:
      'absolute bottom-3 right-3 w-[43px] h-[24px] rounded-full bg-[rgba(0,0,0,0.5)] flex items-center justify-center pt-[2px]',
    sliderStyles: 'rounded-md border border-[#DEE4E9]'
  }

  const ParkinglotPhotoProps = {
    options: sliderOptions,
    items: pin.basic.photos
  }

  return (
    <div className="mt-[16px] w-full px-[16px]">
      <div className="flex flex-col items-center justify-center gap-[24px]">
        <ParkinglotPhotoView {...ParkinglotPhotoProps} />
        {pin.type === PARKINGLOT_TYPE.PARKINGLOT && (
          <ParkinglotPriceInfoView priceInfo={pin.prices.length > 0 ? pin.prices[0].contents.slice(0, 3) : []} />
        )}
        {pin.type === PARKINGLOT_TYPE.SHARE && (
          <SharedParkinglotPriceInfoView priceInfo={pin.prices.length > 0 ? pin.prices[0].contents.slice(1, 2) : []} />
        )}
        {operationTimeInfo.length > 0 && <ParkinglotOperationInfoView operationTime={operationTimeInfo} />}
        {pin.basic.options.length > 0 ? <ParkinglotExtraInfoView options={pin.basic.options} /> : null}
      </div>
    </div>
  )
}

export default ParkinglotInfoView
